export function isAdminUser(user) {
  return String(user?.role || '').trim().toLowerCase() === 'admin';
}

export function protectedAdminMessage(isAdmin) {
  return isAdmin ? null : 'Admin access required.';
}